// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6933) return "static/chunks/0f987275-1cde77b80acada94.js";
	if (chunkId === 7115) return "static/chunks/7105534e-a0f693e1cb91323d.js";
	if (chunkId === 5228) return "static/chunks/5228-6a2039ebbef5d7f4.js";
	if (chunkId === 6812) return "static/chunks/6812-48a6fbc6c4da8f48.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3119":"717a1995","7435":"5fa3da39"}[chunkId] || chunkId) + "." + {"1008":"0f574d0f1f6b8fb0","2126":"5e657752512cf72f","3119":"c4661be2034a6905","3508":"ed1c4e2fd69cdd10","5247":"4f58c09649a5591b","7435":"9bd0d42e36441890","7918":"2f7123d0a683b56c","8360":"2612dac85fb99a54","8672":"0e09b831ebedaffd"}[chunkId] + ".js";
};